import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";

import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "@/style/scss/index.scss";
import "@/style/ali-icon/iconfont.css";

import process from "process";
window.process = process;

//禁用打印
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
}
const app = createApp(App);
app.use(router);
app.use(ElementPlus);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.mount("#app");

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
